import { AuthType } from '../model/AuthType';
import type { Customer } from '../../bff-api/customers/model';

export const isRegistered = (customer: Customer | undefined): boolean =>
    customer?.authType === AuthType.REGISTERED;

export const isGuest = (customer: Customer | undefined): boolean => !isRegistered(customer);
